import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TNenryoTankaGetListReq,
  TNenryoTankaGetListRes,
  TNenryoTankaPutListReq,
} from "./TNenryoTanka"

/**
 * 燃料単価に対するAPIリクエスト用サービス
 *
 * @export
 * @class NenryoTankaService
 * @extends {ConnectApi}
 */
export default class NenryoTankaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TNenryoTankaGetListReq} params
   * @param {(param: TApiResponse<TNenryoTankaGetListRes[]>) => any} resolve
   * @param {(param: TApiResponse<TNenryoTankaGetListRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TNenryoTankaGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TNenryoTankaGetListRes[]>> =
        await this.getInner(`/truckcontrol/NenryoTanka`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TNenryoTankaPutListReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof KyotenService
   */
  put = async (data: TNenryoTankaPutListReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/NenryoTanka`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
